/* Lumora animated logo gallery: attaches shadow roots and runs the small scripted effects. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function ready(host) {
    if (host.shadowRoot) return host.shadowRoot;
    var t = host.querySelector('template[shadowrootmode]');
    if (!t) return null;
    var r = host.attachShadow({ mode: 'open' });
    r.appendChild(t.content.cloneNode(true));
    t.remove();
    return r;
  }
  function cssv(el, n, d) { var v = getComputedStyle(el).getPropertyValue(n).trim(); return v || d; }

  function prox(root, card) {
    var L = root.querySelectorAll('.L');
    if (!L.length) return;
    function mv(e) {
      var p = e.touches ? e.touches[0] : e;
      L.forEach(function (l) {
        var r = l.getBoundingClientRect(), dx = p.clientX - (r.left + r.width / 2), dy = p.clientY - (r.top + r.height / 2), d = Math.hypot(dx, dy), f = Math.max(0, 1 - d / 90);
        l.style.translate = '0 ' + (-14 * f) + 'px'; l.style.scale = 1 + 0.35 * f;
      });
    }
    function rs() { L.forEach(function (l) { l.style.translate = ''; l.style.scale = ''; }); }
    card.addEventListener('mousemove', mv); card.addEventListener('touchmove', mv, { passive: true });
    card.addEventListener('mouseleave', rs); card.addEventListener('touchend', rs);
  }
  function eyes(root, card) {
    var us = root.querySelectorAll('.eyes u');
    function mv(e) {
      var p = e.touches ? e.touches[0] : e;
      us.forEach(function (u) {
        var r = u.parentNode.getBoundingClientRect(), dx = p.clientX - (r.left + r.width / 2), dy = p.clientY - (r.top + r.height / 2), d = Math.max(1, Math.hypot(dx, dy)), m = Math.min(6, d / 12);
        u.style.translate = (dx / d * m) + 'px ' + (dy / d * m) + 'px';
      });
    }
    document.addEventListener('mousemove', mv); card.addEventListener('touchmove', mv, { passive: true });
  }
  function scrambleTo(el, to, done, k) {
    var ch = '#%&@$01XZ', i = 0, L = to.length;
    var h = setInterval(function () {
      var s = ''; for (var j = 0; j < L; j++) s += (j < i / 3) ? to[j] : ch[Math.floor(Math.random() * ch.length)];
      el.textContent = s;
      if (++i > L * 3 + 3) { clearInterval(h); el.textContent = to; if (done) done(); }
    }, 60 * k);
  }
  function scramble(root, k) {
    var el = root.querySelector('.d2'); if (!el) return; var fin = el.textContent;
    (function loop() { scrambleTo(el, fin, function () { setTimeout(loop, 1600 * k); }, k); })();
  }
  function words(root, host, k) {
    var el = root.querySelector('.r1'); if (!el) return; var base = el.textContent;
    var list = [base].concat((host.getAttribute('data-words') || 'SHOP, LUXE, STYLE').split(',').map(function (x) { return x.trim().toUpperCase(); }).filter(Boolean)), i = 0;
    (function loop() { scrambleTo(el, list[i % list.length], function () { setTimeout(loop, 1400 * k); }, k); i++; })();
  }
  function flap(root, k) {
    var f = root.querySelectorAll('.r4 div'), az = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if (!f.length) return;
    (function loop() {
      var n = 0;
      f.forEach(function (d, i) {
        var tg = d.getAttribute('data-ch'), j = 0;
        var h = setInterval(function () {
          d.textContent = tg === ' ' ? ' ' : az[Math.floor(Math.random() * 26)];
          if (++j > 6 + i * 4) { clearInterval(h); d.textContent = tg; if (++n === f.length) setTimeout(loop, 2200 * k); }
        }, 90 * k);
      });
    })();
  }
  function canvas(root, host, card, k) {
    var cv = root.querySelector('canvas.cv'); if (!cv) return;
    var mode = cv.getAttribute('data-mode'), ctx = cv.getContext('2d'), W = 440, H = 200, P = [], t0 = performance.now(), running = true, sp = 1 / k, mx = null, my = null;
    var c1 = host.getAttribute('data-c1'), c2 = host.getAttribute('data-c2');
    var acc = c2 || cssv(card, '--acc', '#b08d57'), acc2 = c1 || cssv(card, '--acc2', '#e5407a');
    var PAL = [acc2, acc, '#ffd02e', '#2ee6d6', '#7c5cff'], Y = 100, LXc = [52, 164, 268, 372], targets = null;
    var txt = card.querySelectorAll('.L'); if (txt.length) { LXc = []; var cr = cv.getBoundingClientRect(); txt.forEach(function (l) { var r = l.getBoundingClientRect(); LXc.push(((r.left + r.width / 2) - cr.left) / (cr.width || 220) * W); }); if (!LXc.length || LXc.some(isNaN)) LXc = [52, 164, 268, 372]; }
    var nL = LXc.length || 4;
    function N(n, f) { for (var i = 0; i < n; i++) P.push(f(i)); }
    if (mode === 'pointer') N(46, function () { return { x: rnd(0, W), y: rnd(0, H), vx: rnd(-.6, .6), vy: rnd(-.6, .6), r: rnd(2, 5), h: Math.random() }; });
    if (mode === 'constellation') N(48, function () { return { x: rnd(0, W), y: rnd(0, H), vx: rnd(-.5, .5), vy: rnd(-.5, .5), r: rnd(2, 4.5), h: Math.random() }; });
    if (mode === 'orbit') N(48, function (i) { return { k: i % nL, a: rnd(0, 6.28), r: rnd(28, 52), s: rnd(.01, .03) * (i % 2 ? 1 : -1), size: rnd(2, 4.5), h: Math.random() }; });
    if (mode === 'form') {
      var o = document.createElement('canvas'); o.width = W; o.height = H; var x = o.getContext('2d');
      x.font = '800 76px Montserrat,system-ui,sans-serif'; x.textAlign = 'center'; x.textBaseline = 'middle';
      var ch = []; txt.forEach(function (l) { ch.push(l.textContent); }); if (!ch.length) ch = 'KAPO'.split('');
      ch.forEach(function (c, i) { x.fillText(c, LXc[i] || 50 + i * 100, Y); });
      var d = x.getImageData(0, 0, W, H).data, pts = [];
      for (var yy = 0; yy < H; yy += 4) for (var xx = 0; xx < W; xx += 4) if (d[(yy * W + xx) * 4 + 3] > 128) pts.push([xx, yy]);
      targets = pts;
      for (var i = 0; i < Math.min(pts.length, 220); i++) { var q = pts[Math.floor(Math.random() * pts.length)]; P.push({ x: rnd(0, W), y: rnd(0, H), tx: q[0], ty: q[1], vx: 0, vy: 0, h: Math.random() }); }
    }
    if (mode === 'pointer') {
      card.addEventListener('mousemove', function (e) { var r = cv.getBoundingClientRect(); mx = (e.clientX - r.left) / r.width * W; my = (e.clientY - r.top) / r.height * H; });
      card.addEventListener('touchmove', function (e) { var p = e.touches[0], r = cv.getBoundingClientRect(); mx = (p.clientX - r.left) / r.width * W; my = (p.clientY - r.top) / r.height * H; }, { passive: true });
      card.addEventListener('mouseleave', function () { mx = null; });
    }
    function draw(now) {
      if (!running) return;
      var t = (now - t0) / 1000 * sp;
      ctx.clearRect(0, 0, W, H);
      if (mode === 'pointer') {
        P.forEach(function (p) {
          if (mx !== null) { var dx = mx - p.x, dy = my - p.y, d = Math.hypot(dx, dy); if (d < 130 && d > 1) { p.vx += dx / d * .05 * sp; p.vy += dy / d * .05 * sp; } }
          p.vx *= .985; p.vy *= .985; p.x += p.vx * sp; p.y += p.vy * sp; if (p.x < 0 || p.x > W) p.vx *= -1; if (p.y < 0 || p.y > H) p.vy *= -1;
          ctx.globalAlpha = .55; ctx.fillStyle = p.h > .5 ? acc2 : acc; ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
        });
        ctx.globalAlpha = .15; ctx.strokeStyle = acc;
        for (var i = 0; i < P.length; i++) for (var j = i + 1; j < P.length; j++) { var dd = Math.hypot(P[i].x - P[j].x, P[i].y - P[j].y); if (dd < 60) { ctx.beginPath(); ctx.moveTo(P[i].x, P[i].y); ctx.lineTo(P[j].x, P[j].y); ctx.stroke(); } }
      }
      if (mode === 'constellation') {
        var ax = W / 2 + Math.sin(t * 1.3) * 190, ay = Y + Math.cos(t * 1.9) * 70;
        P.forEach(function (p) { var dx = ax - p.x, dy = ay - p.y, d = Math.hypot(dx, dy); if (d < 120 && d > 1) { p.vx += dx / d * .05 * sp; p.vy += dy / d * .05 * sp; } p.vx *= .985; p.vy *= .985; p.x += p.vx * sp; p.y += p.vy * sp; if (p.x < 0 || p.x > W) p.vx *= -1; if (p.y < 0 || p.y > H) p.vy *= -1; ctx.globalAlpha = .6; ctx.fillStyle = p.h > .5 ? acc2 : acc; ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill(); });
        ctx.globalAlpha = .16; ctx.strokeStyle = acc;
        for (var a = 0; a < P.length; a++) for (var b = a + 1; b < P.length; b++) { var d2 = Math.hypot(P[a].x - P[b].x, P[a].y - P[b].y); if (d2 < 64) { ctx.beginPath(); ctx.moveTo(P[a].x, P[a].y); ctx.lineTo(P[b].x, P[b].y); ctx.stroke(); } }
        ctx.globalAlpha = .35; ctx.fillStyle = acc2; ctx.beginPath(); ctx.arc(ax, ay, 7, 0, 6.283); ctx.fill();
      }
      if (mode === 'orbit') {
        var act = Math.floor(t / .75) % nL;
        P.forEach(function (p) { p.a += p.s * (p.k === act ? 3 : 1) * sp; var rr = p.r * (p.k === act ? 1.25 : .8), cx = LXc[p.k], x = cx + Math.cos(p.a) * rr * 1.1, y = Y + Math.sin(p.a) * rr * .75; ctx.globalAlpha = p.k === act ? .9 : .4; ctx.fillStyle = p.h > .5 ? acc2 : acc; ctx.beginPath(); ctx.arc(x, y, p.size, 0, 6.283); ctx.fill(); });
      }
      if (mode === 'form' && targets) {
        var f = t % 3;
        P.forEach(function (p) {
          if (f < 1.6) { p.vx += (p.tx - p.x) * .012; p.vy += (p.ty - p.y) * .012; p.vx *= .86; p.vy *= .86; }
          else if (f < 2.1) { p.vx *= .9; p.vy *= .9; }
          else { if (!p.sc) { p.vx = rnd(-5, 5); p.vy = rnd(-5, 5); p.sc = 1; } p.vx *= .97; p.vy *= .97; }
          if (f < .05) p.sc = 0;
          p.x += p.vx; p.y += p.vy; ctx.globalAlpha = .9; ctx.fillStyle = p.h > .5 ? acc2 : acc; ctx.beginPath(); ctx.arc(p.x, p.y, 2.6, 0, 6.283); ctx.fill();
        });
      }
      requestAnimationFrame(draw);
    }
    if (reduce) return;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !running) { running = true; requestAnimationFrame(draw); } else if (!e.isIntersecting) running = false; }); }).observe(host);
    }
    requestAnimationFrame(draw);
  }

  /* ---- transparent logos: pointer vars, ripples, canvas effects ---- */
  function nx(root, host, card, k) {
    var nm = root.querySelector('.nm'); if (!nm) return;
    var sp = 1 / k, W = 210, H = 90, ptr = null, tap = null, lastRip = 0;
    function pos(e) { var r = nm.getBoundingClientRect(); return { x: (e.clientX - r.left) / (r.width || W) * W, y: (e.clientY - r.top) / (r.height || H) * H }; }
    nm.addEventListener('pointermove', function (e) {
      ptr = pos(e); nm.style.setProperty('--mx', ptr.x + 'px'); nm.style.setProperty('--my', ptr.y + 'px'); nm._hv = 1;
      if (nm.hasAttribute('data-rip') && performance.now() - lastRip > 260) {
        lastRip = performance.now(); var d = document.createElement('i'); var ink = nm.querySelector('.ib');
        d.className = ink ? 'ib' : 'rp one'; d.style.cssText = 'left:' + ptr.x + 'px;top:' + ptr.y + 'px;animation-iteration-count:1;animation-delay:0s';
        nm.appendChild(d); setTimeout(function () { d.remove(); }, 3500);
      }
    });
    nm.addEventListener('pointerleave', function () { ptr = null; nm._hv = 0; });
    nm.addEventListener('pointerdown', function (e) { tap = pos(e); });
    var cv = nm.querySelector('canvas.cv2'); if (!cv) return;
    var mode = cv.getAttribute('data-nm'), ctx = cv.getContext('2d'); ctx.scale(2, 2);
    var g1 = cssv(nm, '--g1', '#e5407a'), g2 = cssv(nm, '--g2', '#ffb347'), S = {}, t = 0, running = true;
    function fade(a) { ctx.globalCompositeOperation = 'destination-out'; ctx.fillStyle = 'rgba(0,0,0,' + a + ')'; ctx.fillRect(0, 0, W, H); ctx.globalCompositeOperation = 'source-over'; }
    function glow(x, y, r, c, a) { var g = ctx.createRadialGradient(x, y, 0, x, y, r); g.addColorStop(0, c); g.addColorStop(1, 'transparent'); ctx.globalAlpha = a; ctx.fillStyle = g; ctx.fillRect(x - r, y - r, r * 2, r * 2); ctx.globalAlpha = 1; }
    function burst(x, y) { var P = S.F || (S.F = []); for (var i = 0; i < 34; i++) { var a = rnd(0, 6.283), v = rnd(.4, 1.9); P.push({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, l: 1, col: Math.random() < .5 ? g1 : g2, g: .025 }); } }
    function stepParts(P, dec) {
      for (var i = P.length - 1; i >= 0; i--) { var p = P[i]; p.x += p.vx * sp; p.y += p.vy * sp; p.vy += p.g; p.vx *= .992; p.l -= .016 * dec; if (p.l <= 0) { P.splice(i, 1); continue; } ctx.globalAlpha = Math.min(1, p.l); ctx.fillStyle = p.col; ctx.beginPath(); ctx.arc(p.x, p.y, 1.5, 0, 7); ctx.fill(); }
      ctx.globalAlpha = 1;
    }
    var M = {
      const: function () {
        var P = S.P || (S.P = []); if (!P.length) for (var i = 0; i < 26; i++) P.push({ x: rnd(0, W), y: rnd(0, H), vx: rnd(-.2, .2), vy: rnd(-.2, .2) });
        ctx.clearRect(0, 0, W, H);
        P.forEach(function (p) { p.x += p.vx * sp; p.y += p.vy * sp; if (p.x < 0 || p.x > W) p.vx *= -1; if (p.y < 0 || p.y > H) p.vy *= -1; if (ptr) { var dx = ptr.x - p.x, dy = ptr.y - p.y; if (Math.hypot(dx, dy) < 90) { p.x += dx * .03; p.y += dy * .03; } } });
        ctx.lineWidth = 1;
        for (var a = 0; a < P.length; a++) { for (var b = a + 1; b < P.length; b++) { var d = Math.hypot(P[a].x - P[b].x, P[a].y - P[b].y); if (d < 46) { ctx.strokeStyle = g1; ctx.globalAlpha = (1 - d / 46) * .7; ctx.beginPath(); ctx.moveTo(P[a].x, P[a].y); ctx.lineTo(P[b].x, P[b].y); ctx.stroke(); } } ctx.globalAlpha = 1; ctx.fillStyle = g2; ctx.beginPath(); ctx.arc(P[a].x, P[a].y, 1.6, 0, 7); ctx.fill(); }
      },
      spk: function () {
        fade(.16); var P = S.F || (S.F = []), x = ptr ? ptr.x : 105 + Math.sin(t * 1.4 * sp) * 88, y = ptr ? ptr.y : 45 + Math.sin(t * 2.8 * sp) * 20;
        for (var i = 0; i < 4; i++) { var a = rnd(0, 6.283), v = rnd(.3, 1.6); P.push({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v - .2, l: .75, col: i % 2 ? g1 : g2, g: .04 }); }
        stepParts(P, 1.54); glow(x, y, 7, g2, 1);
      },
      fnt: function () {
        fade(.16); var P = S.F || (S.F = []), tx = ptr ? ptr.x : 105 + Math.sin(t * sp) * 34;
        for (var i = 0; i < 5; i++) { var a = -1.57 + (tx - 105) / 210 * 1.2 + rnd(-.28, .28), v = rnd(2, 3.3); P.push({ x: 105, y: H, vx: Math.cos(a) * v, vy: Math.sin(a) * v, l: 1.1, col: i % 2 ? g1 : g2, g: .07 }); }
        stepParts(P, 1.4);
      },
      rkt: function () {
        fade(.16); var P = S.F || (S.F = []), R = S.R || (S.R = []); S.cd = (S.cd || 0) - .016 * sp;
        if (S.cd <= 0) { S.cd = 1.5; R.push({ x: rnd(60, 150), y: H, tx: rnd(40, 170), ty: rnd(16, 40) }); }
        if (tap) { burst(tap.x, tap.y); tap = null; }
        if (ptr && nm._hv) { S.hc = (S.hc || 0) - 1; if (S.hc <= 0) { S.hc = 40; R.push({ x: ptr.x, y: H, tx: ptr.x, ty: ptr.y }); } }
        for (var i = R.length - 1; i >= 0; i--) { var q = R[i]; q.x += (q.tx - q.x) * .04; q.y -= 1.6 * sp + .6; P.push({ x: q.x, y: q.y, vx: rnd(-.1, .1), vy: .4, l: .4, col: g2, g: 0 }); if (q.y <= q.ty) { burst(q.x, q.y); R.splice(i, 1); } }
        stepParts(P, 1.4);
      }
    };
    var fn = M[mode]; if (!fn) return;
    (function loop() { t += .016; if (running && !document.hidden) fn(); requestAnimationFrame(loop); })();
    if (window.IntersectionObserver) new IntersectionObserver(function (es) { es.forEach(function (e) { running = e.isIntersecting; }); }).observe(host);
  }

  function init(host) {
    if (host.__lgInit) return; var root = ready(host); if (!root) return; host.__lgInit = 1;
    var card = root.querySelector('.c') || root, modes = (host.getAttribute('data-mode') || '').split(' ').filter(Boolean), k = parseFloat(host.getAttribute('data-k')) || 1;
    if (modes.indexOf('prox') > -1) prox(root, card);
    if (modes.indexOf('eyes') > -1) eyes(root, card);
    if (reduce) return;
    if (modes.indexOf('scramble') > -1) scramble(root, k);
    if (modes.indexOf('words') > -1) words(root, host, k);
    if (modes.indexOf('flap') > -1) flap(root, k);
    if (modes.indexOf('canvas') > -1) canvas(root, host, card, k);
    if (modes.indexOf('nx') > -1) nx(root, host, card, k);
  }
  function all() { document.querySelectorAll('.lu-lg').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:section:reorder', all);
})();

/* Lumora logo cursor tracking + tap-hover */
(function () {
  'use strict';
  if (window.__luLgFx) return; window.__luLgFx = 1;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mx = null, my = null, raf = 0;
  var st = new WeakMap();
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function items() { return document.querySelectorAll('.lu-gal[data-tr]:not([data-tr="off"])'); }
  function target(el, k, tr) {
    var r = el.getBoundingClientRect();
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var nx = 0, ny = 0, d = 1;
    if (mx !== null) {
      nx = clamp((mx - cx) / 320, -1, 1); ny = clamp((my - cy) / 220, -1, 1);
      d = Math.min(1, Math.sqrt(nx * nx + ny * ny));
    }
    var o = { tx: 0, ty: 0, rx: 0, ry: 0, rz: 0, sk: 0, sx: 1, sy: 1, th: 0, dx: 0, dy: 0, db: 0, org: '50% 50%' };
    switch (tr) {
      case 'tilt': o.rx = -ny * 14 * k; o.ry = nx * 18 * k; break;
      case 'magnet': o.tx = nx * 10 * k; o.ty = ny * 6 * k; break;
      case 'parallax': o.tx = -nx * 9 * k; o.ty = -ny * 6 * k; break;
      case 'shadow': o.dx = -nx * 10 * k; o.dy = -ny * 8 * k; o.db = mx === null ? 0 : 5; break;
      case 'skew': o.sk = nx * 14 * k; break;
      case 'look': o.rz = nx * 7 * k; o.ty = ny * 3 * k; break;
      case 'zoom': var z = mx === null ? 0 : (1 - d); o.sx = o.sy = 1 + z * 0.16 * k; break;
      case 'hue': o.th = nx * 140 * k; break;
      case 'stretch': var a = Math.abs(nx); o.sx = 1 + a * 0.12 * k; o.sy = 1 - a * 0.05 * k; break;
      case 'swing': o.rz = nx * 12 * k; o.org = '50% 0%'; break;
    }
    return o;
  }
  function frame() {
    raf = 0; var busy = false;
    items().forEach(function (el) {
      var k = parseFloat(getComputedStyle(el).getPropertyValue('--fk')) || 1;
      var tgt = target(el, k, el.getAttribute('data-tr'));
      var s = st.get(el) || (st.set(el, { tx: 0, ty: 0, rx: 0, ry: 0, rz: 0, sk: 0, sx: 1, sy: 1, th: 0, dx: 0, dy: 0, db: 0 }), st.get(el));
      for (var key in s) { var dv = tgt[key] - s[key]; if (Math.abs(dv) > 0.01) { s[key] += dv * 0.14; busy = true; } else s[key] = tgt[key]; }
      el.style.transformOrigin = tgt.org;
      el.style.transform = 'perspective(700px) translate(' + s.tx.toFixed(2) + 'px,' + s.ty.toFixed(2) + 'px) rotateX(' + s.rx.toFixed(2) + 'deg) rotateY(' + s.ry.toFixed(2) + 'deg) rotate(' + s.rz.toFixed(2) + 'deg) skewX(' + s.sk.toFixed(2) + 'deg) scale(' + s.sx.toFixed(3) + ',' + s.sy.toFixed(3) + ')';
      el.style.setProperty('--th', s.th.toFixed(1) + 'deg');
      el.style.setProperty('--dsx', s.dx.toFixed(1) + 'px');
      el.style.setProperty('--dsy', s.dy.toFixed(1) + 'px');
      if (el.getAttribute('data-tr') === 'shadow') { el.style.setProperty('--dsb', s.db.toFixed(1) + 'px'); el.style.setProperty('--dsc', 'rgba(0,0,0,.35)'); }
    });
    if (busy) raf = requestAnimationFrame(frame);
  }
  function kick() { if (!raf) raf = requestAnimationFrame(frame); }
  function init() {
    if (init.done) return; init.done = 1;
    if (!reduce) {
      window.addEventListener('pointermove', function (e) { mx = e.clientX; my = e.clientY; kick(); }, { passive: true });
      document.addEventListener('pointerleave', function () { mx = null; kick(); });
      window.addEventListener('blur', function () { mx = null; kick(); });
      window.addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse') { setTimeout(function () { mx = null; kick(); }, 600); } });
    }
    document.addEventListener('pointerdown', function (e) {
      var g = e.target.closest && e.target.closest('.lu-gal[data-hv]');
      if (g && e.pointerType !== 'mouse') { g.classList.remove('is-hv'); void g.offsetWidth; g.classList.add('is-hv'); setTimeout(function () { g.classList.remove('is-hv'); }, 1400); }
    }, { passive: true });
    kick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { kick(); });
})();
